import { CARTADD, CARTDECREMENT, CARTINCREMENT } from './actionTypes';

export const cartAdd = (id) => {
    return {
        type: CARTADD,
        payload: { 
            id 
        }
    }
};

export const cartIncrement = (id) => {
    return {
        type: CARTINCREMENT,
        payload: { 
            id 
        }
    }
};

export const cartDecrement = (id) => {
    return {
        type: CARTDECREMENT,
        payload: { 
            id 
        }
    }
};